<div class="avatar-container" [style.width.px]="size()" [style.height.px]="size()">
  @if (showImage()) {
  <img class="avatar-content" [src]="src()!" [alt]="name()" loading="lazy" (error)="onImageError()" />
  } @else {
  <div class="avatar-content" [ngStyle]="initialsStyle()">
    {{ initials() }}
  </div>
  }
</div>
